export const LOGIN_RESULT = 'LOGIN_RESULT';
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';

export const USUARIO_SET_USER_INFO = 'USUARIO_SET_USER_INFO';
export const USUARIO_SET_ORGANIZATION_INFO = 'USUARIO_SET_ORGANIZATION_INFO';
export const USUARIO_SET_TWISTED_INFO = 'USUARIO_SET_TWISTED_INFO';

export const STORE_SET_PRODUCT_LIST_COINS = 'STORE_SET_PRODUCT_LIST_COINS';
